import type { NextMatch } from '../../components/Profile/LeagueSummary';

const toMillis = (value: any): number => {
  if (typeof value === 'number') return value < 100000000000 ? value * 1000 : value;
  if (typeof value?.seconds === 'number') return value.seconds * 1000;
  return 0;
};

/** Earliest reserved (mac_durum 1) match still ahead of `now`, formatted in Istanbul time. */
export function findNextMatch(
  matches: Matches.Match[],
  userId: string,
  users: Users.User[],
  now = Date.now(),
): NextMatch | null {
  const next = matches
    .filter(match => match.mac_durum === 1 && toMillis(match.mac_saati) > now)
    .sort((a, b) => toMillis(a.mac_saati) - toMillis(b.mac_saati))[0];
  if (!next) return null;
  const opponentId = next.kul_t_id === userId ? next.kul_r_id : next.kul_t_id;
  const opponent = users.find(user => user.id === opponentId);
  return {
    when: new Intl.DateTimeFormat('tr-TR', {
      weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
      timeZone: 'Europe/Istanbul',
    }).format(new Date(toMillis(next.mac_saati))),
    opponent: opponent ? `${opponent.ad} ${opponent.soyad}` : '—',
  };
}
